import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { PhoneLoginForm } from './PhoneLoginForm';
import { OtpForm } from './OtpForm';
import { useAuthStore } from '../../stores/authStore';
import { BozLogo } from '../common/BozLogo';

export const AuthPage: React.FC = () => {
  const [showOtp, setShowOtp] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const { isAuthenticated, user, checkAuth } = useAuthStore();

  // Check authentication on mount
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  // Redirect if already authenticated
  if (isAuthenticated && user) {
    return <Navigate to="/app" replace />;
  }

  const handleOtpSent = (phone: string) => {
    setPhoneNumber(phone);
    setShowOtp(true);
  };

  const handleBackToLogin = () => {
    setShowOtp(false);
    setPhoneNumber('');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-primary-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        {/* Logo/Brand */}
        <div className="text-center mb-8">
          <div className="mx-auto w-16 h-16 rounded-xl flex items-center justify-center mb-4">
            <BozLogo size={64} />
          </div>
          <h1 className="text-3xl font-bold text-gray-900">Boz Sales</h1>
          <p className="text-gray-600 mt-2">Connect with your sales team</p>
        </div>

        {/* Auth Forms */}
        {showOtp ? (
          <OtpForm
            phoneNumber={phoneNumber}
            onBack={handleBackToLogin}
          />
        ) : (
          <PhoneLoginForm onOtpSent={handleOtpSent} />
        )}

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-xs text-gray-500">
            © 2023 Boz Sales. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};
